import React from 'react';
import { useTranslation } from 'react-i18next';

import { TitleItem } from '../../utils';
import * as S from './ListTitleItem.styles';

export interface ListTitleItemProps {
  item: TitleItem;
  variant: 'default' | 'secondary';
  isSectionCollapsed?: boolean;
  onSectionTitleClick?: () => void;
}

export const ListTitleItem = ({
  item,
  variant,
  isSectionCollapsed,
  onSectionTitleClick,
}: ListTitleItemProps) => {
  const { t } = useTranslation('widget');

  if (!item.title) {
    return null;
  }

  return (
    <S.TitleAndDividerWrapper data-testid="list-title-item-root">
      <S.HideOrShowButtonWrapper>
        <S.ListTitle $variant={variant} data-testid={item.title}>
          {item.title}
        </S.ListTitle>
        {!!item?.isCollapsibleSection && (
          <S.StyledButton
            data-testid="list-title-item-collapse-button"
            iconName={isSectionCollapsed ? 'ChevronLightDown' : 'Minus'}
            label={
              isSectionCollapsed
                ? t('widget:search.show')
                : t('widget:search.hide')
            }
            size="xsmall"
            variant="empty"
            type="button"
            iconPosition="right"
            onClick={onSectionTitleClick}
          />
        )}
      </S.HideOrShowButtonWrapper>

      {variant === 'secondary' && <S.HorizontalDivider />}
    </S.TitleAndDividerWrapper>
  );
};
